<template>
  <v-app light>
    <v-content class="pa-5">
      <v-form ref="form" v-model="valid" lazy-validation>
        
        <v-text-field v-model="email" label="E-mail" required ></v-text-field>
        <v-text-field v-model="password"  label="Senha" required></v-text-field>
        <v-btn>Entrar</v-btn>
        <v-btn>Limpar</v-btn>
      </v-form>
      <!-- <h1>Login</h1> -->

      <v-btn @click="loginGoogle()">Entrar com Google<v-icon right>android</v-icon></v-btn>

      <v-btn @click="loginWithEmail = !loginWithEmail">Entrar com Email</v-btn>

      <v-btn @click="logout()">Sair</v-btn>

      <v-form v-if="loginWithEmail">
        <v-text-field v-model="email" label="E-mail" required ></v-text-field>
        <v-text-field v-model="password" label="Senha" required ></v-text-field>
        <v-btn @click="login()">Logar</v-btn>
      </v-form>

      <v-alert :value="true" v-if="error" type="warning">
				{{ error }}
			</v-alert>

      <pre>{{user}}</pre>

    </v-content>
  </v-app>
</template>

<script>
import { auth, googleProvider } from '../firebaseInit'

var provider = googleProvider
auth.languageCode = 'pt'

export default {
  name: 'Login',
  mounted () {
    
  },
  data: () => ({
    loginWithEmail: false,
    email: null,
    password: null,
    error: null,
    user: null,
  }),
  methods: {
    loginGoogle() {
      this.loginWithEmail = false
      auth.signInWithPopup(provider).then(function(result) {
        this.user = result.user
        // this.$router.push('editor')
      }.bind(this)).catch(function(err) {
        console.log(err)
      })
    },
    login() {
      auth.signInWithEmailAndPassword(this.email, this.password).then(
        data => {
          this.user = data.user
          // this.$router.push('editor')
        },
        function(err) {
          console.log(err)
          switch (err.code) {
            case 'auth/invalid-email':
              this.error = 'Email não cadastrado.'
              break;
            case 'auth/user-disabled':
              this.error = 'Usuário desabilitado.'
              break;
            case 'auth/user-not-found':
              this.error = 'Usuário inexistente.'
              break;
            case 'auth/wrong-password':
              this.error = 'Senha Incorreta.'
              this.password = null
              break;
            default:
              this.error = 'Não foi possível se conectar, tente novamente mais tarde.'
          }
        }.bind(this)
      )
    },
  },
}
</script>

